
// export default TermsAndConditionReplicaModal;
import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

function TermsAndConditionReplicaModal({ show, setShow, data, handleClose, handleAcceptTerms }) {
  const [isAtBottom, setIsAtBottom] = useState(false);
  const scrollableRef = useRef(null);

  // Check if the user has scrolled to the bottom
  const handleScroll = () => {
    if (scrollableRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollableRef.current;
      const isBottom = scrollTop + clientHeight >= scrollHeight - 10; // Allow some margin
      setIsAtBottom(isBottom);
    }
  };

  // Reset scroll position and button state when modal opens
  useEffect(() => {
    if (scrollableRef.current) {
      scrollableRef.current.scrollTop = 0; // Start at the top when modal is opened
      setIsAtBottom(false); // Disable button initially
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      dialogClassName="custom-modal"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="text-center">Terms And Condition</Modal.Title>
      </Modal.Header>
      {/* <Modal.Body>
        <div className="popup_cnt_sec" style={{ overflowY: 'scroll', maxHeight: '75vh', display: "flex", flexDirection: "column-reverse" }}>
          {data && <div dangerouslySetInnerHTML={{ __html: data }}></div>}
        </div>
      </Modal.Body> */}
      <Modal.Body>
        <div
          className="popup_cnt_sec"
          style={{ overflowY: 'scroll', maxHeight: '75vh' }} // Removed flexDirection: "column-reverse"
          ref={scrollableRef}
          onScroll={handleScroll}
        >
          {data && <div dangerouslySetInnerHTML={{ __html: data }}></div>}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button
          className="btn-primary"
          disabled={!isAtBottom}
          variant="secondary"
          onClick={handleAcceptTerms}
        >
          Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TermsAndConditionReplicaModal;

